import Container, { Service } from 'typedi'
import IHttpClientGetParameters from '@/modules/common/contracts/http-client/http-client-get-parameters.interface'
import IHttpClientPostParameters from '@/modules/common/contracts/http-client/http-client-post-parameters.interface'
import IHttpClientPatchParameters from '@/modules/common/contracts/http-client/http-client-patch-parameters.interface'
import IHttpClientDeleteParameters from '@/modules/common/contracts/http-client/http-client-delete-parameters.interface'
import HttpClient from '@/modules/common/services/http-client.service'
import { Product } from '@/modules/level-one/interfaces/product.interface'

const BASE_URL = '/lead-retrieval-products'

@Service()
export default class ProductService {
  public async getProducts () {
    const httpParams: IHttpClientGetParameters = {
      url: BASE_URL,
      requireToken: true
    }
    return await Container.get(HttpClient).get(httpParams)
  }

  public async createProduct (data: Partial<Product>) {
    const httpParams: IHttpClientPostParameters = {
      url: BASE_URL,
      requireToken: true,
      payload: data
    }
    return await Container.get(HttpClient).post(httpParams)
  }

  public async updateProduct (uuid: string, data: Partial<Product>) {
    const httpParams: IHttpClientPatchParameters = {
      url: `${BASE_URL}/${uuid}`,
      requireToken: true,
      payload: data
    }
    return await Container.get(HttpClient).patch(httpParams)
  }

  public async deleteProduct (uuid: string) {
    const httpParams: IHttpClientDeleteParameters = {
      url: `${BASE_URL}/${uuid}`,
      requireToken: true
    }
    return await Container.get(HttpClient).delete(httpParams)
  }

  public async uploadProductImage (uuid: string, type: 'thumbnail' | 'full', image: any) {
    const httpParams: IHttpClientPostParameters = {
      url: `${BASE_URL}/${uuid}/image`,
      requireToken: true,
      payload: { type, image }
    }
    return await Container.get(HttpClient).post(httpParams)
  }

  public async deleteProductImage (uuid: string, type: 'thumbnail' | 'full') {
    const httpParams: IHttpClientDeleteParameters = {
      url: `${BASE_URL}/${uuid}/image/${type}`,
      requireToken: true
    }
    return await Container.get(HttpClient).delete(httpParams)
  }
}
